export type ObjectEmptyValues = null | undefined | '';
export type ObjectWithoutEmptyValues = Record<string, Exclude<unknown, ObjectEmptyValues>>;
